var map = {
	"./1.svg": 5633,
	"./2.svg": 7760,
	"./3.svg": 9147,
	"./add.svg": 8475,
	"./alipay.svg": 9224,
	"./applet.svg": 6889,
	"./article-create.svg": 3545,
	"./article-ranking.svg": 8073,
	"./article.svg": 2188,
	"./auto-scale.svg": 3081,
	"./back.svg": 8802,
	"./base-data.svg": 3599,
	"./bell.svg": 4192,
	"./bind-phone.svg": 2374,
	"./branch-boke.svg": 8874,
	"./branch-frabric.svg": 7879,
	"./branch-maker.svg": 4013,
	"./branch-shop.svg": 1618,
	"./c1.svg": 3263,
	"./c2.svg": 1512,
	"./c3.svg": 6802,
	"./c4.svg": 5389,
	"./camera.svg": 7682,
	"./camera1.svg": 6905,
	"./cart-down.svg": 1161,
	"./change-theme.svg": 3920,
	"./chart.svg": 2777,
	"./close.svg": 3812,
	"./cloth.svg": 3269,
	"./code.svg": 9245,
	"./contactus.svg": 8059,
	"./customerservices.svg": 4795,
	"./dashboard.svg": 1528,
	"./data-upload.svg": 3119,
	"./deamon.svg": 5132,
	"./delete.svg": 9281,
	"./diagnosis.svg": 4103,
	"./down.svg": 5134,
	"./download (2).svg": 5427,
	"./download.svg": 5056,
	"./edit.svg": 3603,
	"./empty.svg": 8311,
	"./error.svg": 4933,
	"./example.svg": 2333,
	"./exit-fullscreen.svg": 2263,
	"./eye-open.svg": 1976,
	"./eye.svg": 8357,
	"./fullscreen.svg": 2209,
	"./gouxuan.svg": 5917,
	"./gouxuan1.svg": 1025,
	"./guide.svg": 4431,
	"./hamburger-closed.svg": 972,
	"./hamburger-opened.svg": 3794,
	"./heart.svg": 9644,
	"./histoires.svg": 1053,
	"./home.svg": 9430,
	"./home1.svg": 8752,
	"./info.svg": 1514,
	"./international.svg": 2922,
	"./introduce.svg": 3662,
	"./language.svg": 1196,
	"./link.svg": 4751,
	"./loading.svg": 905,
	"./loading1.svg": 7958,
	"./medtruansfer.svg": 4955,
	"./moneyaccount.svg": 7722,
	"./myreg.svg": 3022,
	"./nested.svg": 4689,
	"./new.svg": 8749,
	"./next.svg": 1058,
	"./outlinepay.svg": 9710,
	"./package.svg": 6896,
	"./password.svg": 8652,
	"./permission.svg": 3156,
	"./person.svg": 5273,
	"./personnel-info.svg": 5848,
	"./personnel-manage.svg": 2090,
	"./personnel.svg": 4105,
	"./play.svg": 6030,
	"./pointleft.svg": 6680,
	"./prev.svg": 747,
	"./qq.svg": 1337,
	"./refresh.svg": 4842,
	"./reply.svg": 2907,
	"./require.svg": 986,
	"./reward.svg": 7422,
	"./role.svg": 1208,
	"./scales.svg": 989,
	"./scales1.svg": 9345,
	"./search.svg": 5840,
	"./search1.svg": 9088,
	"./setting.svg": 5598,
	"./setting1.svg": 2497,
	"./shared.svg": 5129,
	"./shift.svg": 8738,
	"./shop.svg": 4597,
	"./size.svg": 7040,
	"./star.svg": 5167,
	"./success.svg": 3483,
	"./table.svg": 547,
	"./tel.svg": 3816,
	"./tree.svg": 6257,
	"./up.svg": 6875,
	"./upload.svg": 947,
	"./user.svg": 711,
	"./video.svg": 1039,
	"./warn.svg": 2866,
	"./wechat.svg": 1540,
	"./wx.svg": 7796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7933;